import type { FC } from 'react'

export const Windows: FC = () => {
  return (
    <svg viewBox="0 0 128 128" aria-hidden="true">
      <path
        fill="#00ADEF"
        d="M126 1.637l-67 9.834v49.831l67-.534zM1.647 66.709l.003 42.404 50.791 6.983-.04-49.057zM58.467 67.389l.094 49.465 67.376 9.509.016-58.863zM1.61 19.297l.047 42.383 50.791-.289-.023-49.016z"
      />
    </svg>
  )
}
